// Vendor Libs
import actionsServiceCaller from '../lib-app/actions-service-caller';
import servicesConfig from '../../config/services-config';

export function updateShelf(shelfData) {
    return dispatch => {
        const dispatchFetched = () => {
            dispatch({
                type: 'UPDATE_SHELF_FETCH_FULFILLED',
                payload: {
                    error: null,
                    fetched: true,
                    fetching: false,
                },
            });
        };
        const dispatchError = error => {
            dispatch({
                type: 'UPDATE_SHELF_FETCH_REJECTED',
                payload: {
                    fetched: true,
                    fetching: false,
                    error,
                },
            });
        };
        const actionParams = {
            servicesDataKey: 'updateShelf',
            servicesConfig: servicesConfig.updateShelf,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'UPDATE_SHELF_FETCH',
        });
        actionsServiceCaller(actionParams, shelfData);
    };
}

export function reorderShelves(shelfData) {
    return dispatch => {
        const dispatchFetched = () => {
            dispatch({
                type: 'REORDER_SHELF_FETCH_FULFILLED',
                payload: {
                    error: null,
                    fetched: true,
                    fetching: false,
                },
            });
        };
        const dispatchError = error => {
            dispatch({
                type: 'REORDER_SHELF_FETCH_REJECTED',
                payload: {
                    fetched: true,
                    fetching: false,
                    error,
                },
            });
        };
        const actionParams = {
            servicesDataKey: 'updateShelf',
            servicesConfig: servicesConfig.updateShelf,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'REORDER_SHELF_FETCH',
        });
        actionsServiceCaller(actionParams, shelfData);
    };
}

export function removeShelves(shelfData, shelvesToDelete) {
    return dispatch => {
        const dispatchFetched = () => {
            dispatch({
                type: 'REMOVE_SHELF_FETCH_FULFILLED',
                payload: {
                    error: null,
                    fetched: true,
                    fetching: false,
                },
            });

            shelvesToDelete.forEach(element => {
                fetch('/catalog/shelf/' + element.ShelfDTO.id, {method: 'DELETE'});
            });
        };
        const dispatchError = error => {
            dispatch({
                type: 'REMOVE_SHELF_FETCH_REJECTED',
                payload: {
                    fetched: true,
                    fetching: false,
                    error,
                },
            });
        };
        const actionParams = {
            servicesDataKey: 'removeShelves',
            servicesConfig: servicesConfig.updateShelf,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'REMOVE_SHELF_FETCH',
        });
        actionsServiceCaller(actionParams, shelfData);
    };
}

export function clearError() {
    return dispatch => {
        dispatch({
            type: 'ADD_SHELF_CLEAR_ERROR',
        });
    };
}

export function addShelfReset() {
    return dispatch => {
        dispatch({
            type: 'ADD_SHELF_RESET',
        });
    };
}
